import {
  ApiResponse,
  Offering,
  OfferingsViaTagPutRequest,
  Tag,
  TagCategory,
  TagId,
  TagPostRequest,
  TagsViaOfferingPutRequest,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getTags = async () => {
  const response = await api.get<ApiResponse<Tag[]>>('/tags');

  return unwrapApiResponse(response.data);
};

export const getTagCategories = async () => {
  const response = await api.get<ApiResponse<TagCategory[]>>(`/tags/categories`);

  return unwrapApiResponse(response.data);
};

export const getTagsByCategory = async (category: string) => {
  const response = await api.get<ApiResponse<Tag[]>>(`/tags/categories/${category}`);

  return unwrapApiResponse(response.data);
};

export const putTagsOnOfferingByOfferingId = async ({ offeringId, ...rest }: TagsViaOfferingPutRequest) => {
  const response = await api.post<ApiResponse<Offering>>(`/offerings/${offeringId}/tags`, rest);

  return unwrapApiResponse(response.data);
};

export const putOfferingsOnTagByTagId = async ({ tagId, offeringIds }: OfferingsViaTagPutRequest) => {
  const response = await api.post<ApiResponse<Tag>>(`/tags/${tagId}/offerings`, { offeringIds });

  return unwrapApiResponse(response.data);
};

export const postCreateNewTag = async (tagRequest: TagPostRequest) => {
  const response = await api.post<ApiResponse<Tag>>('/tags', tagRequest);

  return unwrapApiResponse(response.data);
};

export const deleteTagByTagId = async (tagId: TagId) => {
  const response = await api.delete<ApiResponse<Tag>>(`/tags/${tagId}`);

  return unwrapApiResponse(response.data);
};
